export enum ChipColorEnum {
  ORANGE = '#e64a19',
  BLUE = '#3498db'
}
